import _ from 'lodash';
import { del, get, patch, post } from './agent';
import { QueryString } from '~/utils';

const xeroExport = (workspacesUrl) => {
  const url = _([workspacesUrl, 'xero-export']).compact().join('/');

  return {
    get: () => get(url),
    setup: (body) => post(url, body),
    updateSettings: (body) => patch(url.concat('/settings'), body),
    remove: () => del(url),
    getReportFile: (reportId, query) =>
      get(url.concat('/reports/').concat(reportId).concat(new QueryString(query).toString(true))),
  };
};

export default xeroExport;
